import React, { useState } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  MenuItem,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../context/ThemeContext";
import Logo from "../../../assets/LogoNew2.png";

const Navbar = ({ scrollToSection }) => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    handleCloseNavMenu();
  };

  return (
    <AppBar
      position="sticky"
      sx={{ bgcolor: "white", boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            {/* <Box component="img" src={Logo1} alt="OTS Logo" sx={{ height: 50, mr: 1 }} /> */}
            <Box
              sx={{
                height: 50,
                width: 50,
                // mr: 1.5,
                display: "inline-block",
                backgroundColor: theme.primary,

                maskImage: `url(${Logo})`,
                WebkitMaskImage: `url(${Logo})`,
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",

                maskSize: "120%",
                WebkitMaskSize: "120%",

                maskPosition: "center",
                WebkitMaskPosition: "center",
              }}
            />
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                flexDirection: "column",
                lineHeight: 0.95,
              }}
            >
              {/* Owner Tenant */}
              <Typography
                sx={{
                  // ...goldGradient,
                  background: `linear-gradient(90deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
                  // "linear-gradient(90deg, #c9a35c 0%, #e6c27a 50%, #a07b3a 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "20px",
                  fontWeight: 600,
                  letterSpacing: "0.04em",
                }}
              >
                Owner Tenant
              </Typography>

              {/* SOLUTION */}
              <Typography
                sx={{
                  // ...goldGradient,
                  background: `linear-gradient(90deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
                  // "linear-gradient(90deg, #c9a35c 0%, #e6c27a 50%, #a07b3a 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "18px",
                  fontWeight: 500,
                  letterSpacing: "0.40em",
                  mt: "-5px",
                }}
              >
                SOLUTION
              </Typography>
            </Box>
          </Box>

          {/* Desktop Menu */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 1,
              alignItems: "center",
            }}
          >
            <Button
              sx={{ color: "#333", fontWeight: 500 }}
              onClick={() => handleNavClick("why-choose")}
            >
              Why OTS
            </Button>
            <Button
              sx={{ color: "#333", fontWeight: 500 }}
              onClick={() => handleNavClick("how-it-works")}
            >
              How It Works
            </Button>
            <Button
              sx={{ color: "#333", fontWeight: 500 }}
              onClick={() => handleNavClick("features")}
            >
              Features
            </Button>
            <Button
              sx={{ color: "#333", fontWeight: 500 }}
              onClick={() => handleNavClick("about-us")}
            >
              About Us
            </Button>
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            <Button
              variant="outlined"
              sx={{
                borderColor: theme.primary,
                color: theme.primary,
                fontWeight: 600,
                px: 3,
                mr: 1,
                "&:hover": {
                  borderColor: theme.primaryHover,
                  bgcolor: theme.lightBg,
                },
              }}
              onClick={() => navigate("/login", { state: { type: "Tenant" } })}
            >
              Tenant Login
            </Button>
            <Button
              variant="contained"
              sx={{
                bgcolor: theme.primary,
                fontWeight: 600,
                px: 3,
                "&:hover": { bgcolor: theme.primaryHover },
              }}
              onClick={() =>
                navigate("/login", { state: { type: "Landlord" } })
              }
            >
              Owner Login
            </Button>
          </Box>

          {/* Mobile Menu */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              sx={{ color: "#333" }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={() => handleNavClick("why-choose")}>
                Why OTS
              </MenuItem>
              <MenuItem onClick={() => handleNavClick("how-it-works")}>
                How It Works
              </MenuItem>
              <MenuItem onClick={() => handleNavClick("features")}>
                Features
              </MenuItem>
              <MenuItem onClick={() => handleNavClick("pricing")}>
                Pricing
              </MenuItem>
              <MenuItem onClick={() => handleNavClick("about-us")}>
                About Us
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={() => {
                  handleCloseNavMenu();
                  navigate("/login", { state: { type: "Tenant" } });
                }}
              >
                Tenant Login
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleCloseNavMenu();
                  navigate("/login", { state: { type: "Landlord" } });
                }}
              >
                Owner Login
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
